import React, { useState, useEffect, Suspense, Component } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layouts from "./Components/Common/layout/Layouts.js";
import "./App.css"

function App() {
  const Dashboard = React.lazy(() => import("./Components/pages/Dashboard/Dashboard.js"));
  const Login = React.lazy(() => import("./Components/pages/Auth/Login.js"));
  const Notification = React.lazy(() => import("./Components/pages/Notification/Notification.js"));
  const Chat = React.lazy(() => import("./Components/pages/chat/Chat.js"));
  const Teams = React.lazy(() => import("./Components/pages/Teams/Ourteams.js"));
  const Version = React.lazy(() => import("./Components/pages/Admin/Version.js"));
  const Overview = React.lazy(() => import("./Components/pages/Overview/Overview.js"));
  const Doctor = React.lazy(() => import("./Components/pages/Management/Doctor.js"));
  const Patient = React.lazy(() => import("./Components/pages/Management/Patient.js"));
  const Speciality = React.lazy(() => import("./Components/pages/Tools/Speciality/Speciality.js"));
  const Qualification = React.lazy(() => import("./Components/pages/Tools/Qulification/Qulification.js"));
  const StateMedicalCouncil = React.lazy(() => import("./Components/pages/Tools/StateCouncil/StateCouncil.js"));
  const LaboratoryCategory = React.lazy(() => import("./Components/pages/Tools/Laboratory/LaboratoryCategory.js"));
  const Laboratory = React.lazy(() => import("./Components/pages/Tools/Laboratory/Laboratory.js"));
  const Payment = React.lazy(() => import("./Components/pages/Payment/Payment.js"));
  const Banner = React.lazy(() => import("./Components/pages/Tools/Banner/Banner.js"));




  const DashBoard = (Component) => {
    return (
      <Layouts>
        <Component />

    </Layouts>
    );
  };

  
  const token = JSON.parse(localStorage.getItem("adminlogin"));

  const Secure = (Component) => {
    if (!token) {
      return <Navigate to="/" />;
    }

    return DashBoard(Component);

  }

  const InSecure = (Component) => {
    if (token) {
      return <Navigate to="/dashboard" />;
    }
    return <Component />;
  };

  const routes = [
    { path: "/dashboard", element: Secure(Dashboard) },
    { path: "/docters", element: Secure(Doctor) },
    { path: "/patients", element: Secure(Patient) },
    { path: "/notification", element: Secure(Notification) },
    // { path: "/chat", element: Secure(Chat) },
    { path: "/teams", element: Secure(Teams) },
    { path: "/payments", element: Secure(Payment) },
    { path: "/", element: InSecure(Login) },
    { path: "/qualification", element: Secure(Qualification) },
    { path: "/version", element: Secure(Version) },
    { path: "/overview", element: Secure(Overview) },  
    { path: "/speciality", element: Secure(Speciality) },  
    { path: "/medical-councils", element: Secure(StateMedicalCouncil) },
    { path: "/laboratory", element: Secure(Laboratory) },
    { path: "/laboratory-category", element: Secure(LaboratoryCategory) },
    { path: "/banner", element: Secure(Banner) },


    


    

    

    


    
];


return (
    <Router>
     <Suspense
  fallback={
    <div className="loader-wrapper">
      <div className="loader-card">
        <div className="logo"></div>

        <div className="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="loading-text">Please wait...</div>
      </div>
    </div>
  }
>

        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

